export const name = 'navigateUrl';
export const description = 'Navigates the user to a different page in the application.';
export const parameters = {
  path: 'The path to navigate to, e.g. "/home", "/statistics", "/daily-posts", "/database/tables", "/database/upload", "/database/ai", "/planned-costs", "/own-contracts", "/subcontractor-contracts", "/own-contract-progress", "/subcontractor-contract-progress", "/project-numbers", "/settings", "/help".'
};
export const outputTextForUI = 'Navigáció indítása';
export const useOnMobile = false;

export function navigateUrl(args: { path: string }) {
  if (!args || !args.path) {
    throw new Error('A "path" paraméter megadása kötelező.');
  }

  // Ensure absolute path format
  let targetPath = args.path;
  if (!targetPath.startsWith('/')) {
    targetPath = '/' + targetPath;
  }

  const event = new CustomEvent('app-navigate', {
    detail: { path: targetPath },
    cancelable: true
  });

  const handled = !window.dispatchEvent(event);

  if (!handled) {
    // Fallback: full browser reload navigation
    window.location.pathname = targetPath;
  }

  return {
    success: true,
    path: targetPath,
    navigationType: handled ? 'client-side' : 'full-reload'
  };
}
